import { reportUnexpectedError } from '@/shared/infrastructure/observability/reportUnexpectedError'
import type { ModuleVisibilityRepository } from '../application/ModuleVisibilityRepository'

export function createResilientModuleVisibilityRepository(
  primary: ModuleVisibilityRepository,
  fallback: ModuleVisibilityRepository,
): ModuleVisibilityRepository {
  return {
    async listModules() {
      try {
        return await primary.listModules()
      } catch (error) {
        reportUnexpectedError(error, {
          feature: 'settings',
          operation: 'module-visibility-list',
          fallback: true,
        })
        const result = await fallback.listModules()
        return {
          ...result,
          meta: {
            ...result.meta,
            source: 'fixture-fallback',
            fallbackReason: 'APP_MODULE_SETTINGS_REMOTE_UNAVAILABLE',
          },
        }
      }
    },
    setModuleActive(command) {
      return primary.setModuleActive(command)
    },
  }
}
